/* MCR search page: animated (typed) placeholder + lazy tab counts. */
(function () {
  'use strict';
  if (window.__mcrSearchInit) return;
  window.__mcrSearchInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Typed placeholder ---------- */
  function typed(input) {
    var phrases = (input.getAttribute('data-mcr-typed-placeholder') || '')
      .split('|')
      .map(function (p) { return p.trim(); })
      .filter(Boolean);
    if (phrases.length < 1 || reduce) return;
    var base = input.getAttribute('placeholder') || '';
    var i = 0;
    var c = 0;
    var deleting = false;
    var timer = null;
    function tick() {
      if (document.activeElement === input || input.value) {
        input.setAttribute('placeholder', base);
        timer = setTimeout(tick, 1200);
        return;
      }
      var word = phrases[i % phrases.length];
      c += deleting ? -1 : 1;
      input.setAttribute('placeholder', word.slice(0, c));
      var delay = deleting ? 35 : 70;
      if (!deleting && c >= word.length) {
        deleting = true;
        delay = 1600;
      } else if (deleting && c <= 0) {
        deleting = false;
        i++;
        delay = 350;
      }
      timer = setTimeout(tick, delay);
    }
    // Only animate while visible
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!timer) timer = setTimeout(tick, 900);
        } else if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }).observe(input);
    } else {
      timer = setTimeout(tick, 900);
    }
  }

  /* ---------- Tab counts via Section Rendering API ---------- */
  function counts(nav) {
    var terms = nav.getAttribute('data-terms');
    if (!terms) return;
    nav.querySelectorAll('[data-mcr-tab-count]').forEach(function (el) {
      if (el.textContent.trim() !== '') return;
      var type = el.getAttribute('data-mcr-tab-count');
      var url =
        ((window.MCRConfig && window.MCRConfig.routes && window.MCRConfig.routes.search) || '/search') +
        '?q=' + encodeURIComponent(terms) +
        '&options%5Bprefix%5D=last' +
        (type !== 'all' ? '&type=' + encodeURIComponent(type) : '') +
        '&section_id=mcr-search-counts';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html && html.match(/data-mcr-search-count="(\d+)"/);
          if (m) el.textContent = m[1];
        })
        .catch(function () {});
    });
  }

  function init() {
    document.querySelectorAll('[data-mcr-typed-placeholder]').forEach(typed);
    var nav = document.querySelector('[data-mcr-search-tabs]');
    if (!nav) return;
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { counts(nav); }, { timeout: 2500 });
    else setTimeout(function () { counts(nav); }, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
